"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(Component) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inheritsLoose(_class, _React$PureComponent);

    function _class() {
      return _React$PureComponent.apply(this, arguments) || this;
    }

    var _proto = _class.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          forceAccept = _this$props.forceAccept,
          accept = _this$props.accept;
      return _react.default.createElement(Component, _extends({}, this.props, {
        accept: forceAccept || accept,
        forceAccept: !!forceAccept
      }));
    };

    return _class;
  }(_react.default.PureComponent), _defineProperty(_class, "propTypes", {
    accept: _propTypes.default.string,
    forceAccept: _propTypes.default.string
  }), _temp;
};

exports.default = _default;